module.exports = __webpack_public_path__ + "img/BOOK.96d07662.png";